import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_TRACKING_ID = process.env.REACT_APP_GTAG_KEY;

const usePageTracking = () => {
    const location = useLocation();
    useEffect(() => {
        if (typeof window.gtag === "function")
        {
            window.gtag("config", GA_TRACKING_ID, {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);
};

export default usePageTracking;
